// Auto-generated seriesConfig from MDX frontmatter
import type { Series } from "./series";

export const seriesConfig: Series[] = [
  {
    slug: "algorithmic-trading",
    title: "Algorithmic Trading",
    description: "",
    icon: "📚",
    color: "blue",
    category: "execution",
    difficulty: "advanced",
    manuals: [
      {
        slug: "execution-algorithms",
        title: "Execution Algorithms & Trade Implementation",
        summary: 
          "Master TWAP, VWAP, implementation shortfall, and advanced execution algorithms for optimal trade execution and market impact minimisation",
        duration: "70 min",
        price: 2.49,
        gumroadId: "execution-algorithms-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["algorithms","execution","market-impact","optimisation"],
        prerequisites: [],
        category: "execution",
        tier: "expert",
      },
      {
        slug: "high-frequency-trading",
        title: "High-Frequency Trading: Technology & Strategy",
        summary: 
          "Understand HFT strategies, latency optimisation, market making, and the technology infrastructure powering modern electronic trading",
        duration: "30 min",
        price: 1.99,
        gumroadId: "hft-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["hft","latency","market-making","technology"],
        prerequisites: [],
        category: "hft",
        tier: "expert",
      },
      {
        slug: "market-microstructure",
        title: "Market Microstructure",
        summary: 
          "Professional finance manual covering market microstructure",
        duration: "50 min",
        price: 2.49,
        gumroadId: "market-microstructure",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "systematic-strategies",
        title: "Systematic Strategies",
        summary: 
          "Professional finance manual covering systematic strategies",
        duration: "50 min",
        price: 2.49,
        gumroadId: "systematic-strategies",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
    ],
  },
  {
    slug: "blockchain-defi",
    title: "Blockchain Defi",
    description: "",
    icon: "📚",
    color: "blue",
    category: "blockchain-defi",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "blockchain-technology",
        title: "Blockchain Technology",
        summary: 
          "Professional finance manual covering blockchain technology",
        duration: "25 min",
        price: 0,
        gumroadId: "blockchain-technology",
        featured: true,
        difficulty: "intermediate",
        tags: ["blockchain","DLT","smart-contracts","cryptocurrency","DeFi","finance"],
        prerequisites: [],
        category: "blockchain-defi",
        free: true,
      },
      {
        slug: "create-cryptocurrency",
        title: "Create Your Own Cryptocurrency",
        summary: 
          "Complete guide to creating your own cryptocurrency from scratch. Includes production-ready Python toolkit, genesis block mining, wallet generation, and exchange listing roadmap.",
        duration: "70 min",
        price: 24.99,
        gumroadId: "create-cryptocurrency",
        featured: true,
        difficulty: "advanced",
        tags: ["cryptocurrency","blockchain","Python","mining","wallet","genesis-block","tokenomics"],
        prerequisites: ["blockchain-technology","cryptocurrency-fundamentals"],
        category: "blockchain-defi",
        tier: "premium",
      },
      {
        slug: "cryptocurrency-fundamentals",
        title: "Cryptocurrency Fundamentals",
        summary: 
          "Essential knowledge of cryptocurrencies, digital wallets, mining, and crypto market dynamics",
        duration: "60 min",
        price: 2.49,
        gumroadId: "crypto-fundamentals-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["cryptocurrency","bitcoin","digital-assets","wallets"],
        prerequisites: [],
        category: "fundamentals",
        tier: "professional",
      },
      {
        slug: "defi-protocols",
        title: "DeFi Protocols",
        summary: 
          "Master decentralized finance protocols including AMMs, lending platforms, yield farming strategies, and risk management with hands-on Python implementations",
        duration: "30 min",
        price: 1.99,
        gumroadId: "defi-protocols",
        featured: false,
        difficulty: "advanced",
        tags: ["DeFi","AMM","yield-farming","Uniswap","Aave","liquidity","smart-contracts"],
        prerequisites: ["cryptocurrency-fundamentals"],
        category: "blockchain-defi",
        tier: "expert",
      },
      {
        slug: "digital-asset-trading",
        title: "Digital Asset Trading",
        summary: 
          "Professional finance manual covering digital asset trading",
        duration: "30 min",
        price: 1.99,
        gumroadId: "digital-asset-trading",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "julia-whitepaper",
        title: "Julia (JLA) Whitepaper",
        summary: "",
        duration: "25 min",
        price: 1.99,
        gumroadId: "julia-whitepaper",
        featured: false,
        difficulty: "intermediate",
        tags: [],
        prerequisites: [],
        category: "Blockchain & DeFi",
        seriesOrder: 5,
      },
    ],
  },
  {
    slug: "central-banking",
    title: "Central Banking",
    description: "",
    icon: "📚",
    color: "blue",
    category: "central-banking",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "central-bank-operations",
        title: "Central Bank Operations",
        summary: 
          "Professional finance manual covering central bank operations",
        duration: "20 min",
        price: 1.99,
        gumroadId: "central-bank-operations",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "financial-stability",
        title: "Financial Stability",
        summary: 
          "Professional finance manual covering financial stability",
        duration: "15 min",
        price: 1.99,
        gumroadId: "financial-stability",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "monetary-policy",
        title: "Monetary Policy",
        summary: 
          "Professional finance manual covering monetary policy",
        duration: "25 min",
        price: 1.99,
        gumroadId: "monetary-policy",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "quantitative-easing",
        title: "Quantitative Easing",
        summary: 
          "Professional finance manual covering quantitative easing",
        duration: "25 min",
        price: 1.99,
        gumroadId: "quantitative-easing",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
    ],
  },
  {
    slug: "collateral-risk",
    title: "Collateral Risk",
    description: "",
    icon: "📚",
    color: "blue",
    category: "collateral-risk",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "collateral-management",
        title: "Collateral Management",
        summary: 
          "Professional finance manual covering collateral management",
        duration: "25 min",
        price: 1.99,
        gumroadId: "collateral-management",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "collateral-optimisation",
        title: "Collateral Optimisation for Derivatives Portfolios",
        summary: 
          "A comprehensive professional guide to the principles, regulatory context, and practical implementation of collateral optimisation for derivatives portfolios",
        duration: "30 min",
        price: 1.99,
        gumroadId: "collateral-optimisation-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["collateral","risk","derivatives","treasury","SIMM","optimisation","funding"],
        prerequisites: ["collateral-management","margin-requirements"],
        category: "risk",
        tier: "professional",
      },
      {
        slug: "collateral-pricing",
        title: "Collateral Pricing",
        summary: 
          "Comprehensive guide to collateral valuation, haircuts, and pricing methodologies in secured financing",
        duration: "15 min",
        price: 1.99,
        gumroadId: "collateral-pricing",
        featured: false,
        difficulty: "intermediate",
        tags: ["collateral","pricing","haircuts","valuation","repo","securities lending"],
        prerequisites: [],
        category: "risk",
        tier: "professional",
      },
      {
        slug: "margin-requirements",
        title: "Margin Requirements",
        summary: 
          "Comprehensive guide to initial and variation margin, regulatory requirements, and margin calculation methodologies",
        duration: "10 min",
        price: 0.99,
        gumroadId: "margin-requirements",
        featured: false,
        difficulty: "advanced",
        tags: ["margin","initial margin","variation margin","SIMM","collateral","derivatives"],
        prerequisites: [],
        category: "risk",
        tier: "professional",
      },
    ],
  },
  {
    slug: "commodity-markets",
    title: "Commodity Markets",
    description: "",
    icon: "📚",
    color: "blue",
    category: "commodity-markets",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "agricultural-commodities",
        title: "Agricultural Commodities: Grains, Livestock & Softs",
        summary: 
          "Complete guide to agricultural commodity trading including grains, livestock, and soft commodities with seasonal patterns and weather risk management",
        duration: "20 min",
        price: 1.99,
        gumroadId: "agricultural-commodities-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["agriculture","grains","livestock","softs","weather","seasonal","commodities"],
        prerequisites: [],
      },
      {
        slug: "commodity-risk-management",
        title: "Commodity Risk Management & Hedging",
        summary: 
          "Advanced risk management techniques for commodity portfolios including hedging strategies, basis risk, and operational risk management",
        duration: "20 min",
        price: 1.99,
        gumroadId: "commodity-risk-management-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["commodities","risk-management","hedging","basis","VAR","portfolio"],
        prerequisites: [],
      },
      {
        slug: "energy-derivatives",
        title: "Energy Derivatives",
        summary: "",
        duration: "30 min",
        price: 1.99,
        gumroadId: "energy-derivatives",
        featured: false,
        difficulty: "advanced",
        tags: ["energy","derivatives","crude-oil","natural-gas","commodities","hedging"],
        prerequisites: ["derivatives-fundamentals"],
        category: "commodity-markets",
      },
      {
        slug: "metals-trading",
        title: "Metals Trading: Precious & Industrial Metals",
        summary: 
          "Comprehensive guide to precious and industrial metals trading, covering gold, silver, platinum, copper, and aluminum with hedging strategies",
        duration: "20 min",
        price: 1.99,
        gumroadId: "metals-trading-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["metals","gold","silver","copper","aluminum","commodities","hedging"],
        prerequisites: [],
      },
    ],
  },
  {
    slug: "credit-instruments",
    title: "Credit Instruments",
    description: "",
    icon: "📚",
    color: "blue",
    category: "credit-instruments",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "corporate-credit-analysis",
        title: "Corporate Credit Analysis",
        summary: 
          "Professional finance manual covering corporate credit analysis",
        duration: "50 min",
        price: 2.49,
        gumroadId: "corporate-credit-analysis",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "corporate-finance",
        title: "Corporate Finance & Valuation",
        summary: 
          "Comprehensive guide to corporate valuation, M&A analysis, and capital structure decisions",
        duration: "25 min",
        price: 1.99,
        gumroadId: "corporate-finance-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["corporate-finance","valuation","M&A","DCF","capital-structure"],
        prerequisites: ["financial-statement-analysis"],
        category: "credit",
        tier: "professional",
      },
      {
        slug: "credit-default-swaps-current",
        title: "Credit Default Swaps",
        summary: 
          "A comprehensive professional guide to credit default swap mechanics, pricing methodologies, trading strategies, and risk management frameworks with real-world implementation examples",
        duration: "25 min",
        price: 1.99,
        gumroadId: "credit-default-swaps-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["cds","credit-protection","default-risk","credit-derivatives","risk-management","portfolio-hedging"],
        prerequisites: ["bond-mathematics","derivatives-fundamentals"],
        category: "derivatives",
        tier: "expert",
      },
      {
        slug: "credit-default-swaps",
        title: "Credit Default Swaps",
        summary: 
          "A comprehensive professional guide to credit default swap mechanics, pricing methodologies, trading strategies, and risk management frameworks. Covers contract fundamentals, market structure, regulatory environment, and advanced portfolio applications with real-world case studies and implementation examples.",
        duration: "90 min",
        price: 2.49,
        gumroadId: "credit-default-swaps-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["cds","credit-protection","default-risk","credit-derivatives","risk-management","portfolio-hedging"],
        prerequisites: ["bond-mathematics","derivatives-fundamentals"],
        category: "derivatives",
        tier: "expert",
      },
      {
        slug: "credit-derivatives",
        title: "Credit Derivatives",
        summary: 
          "Comprehensive guide to credit derivative instruments, pricing, and risk management applications",
        duration: "20 min",
        price: 1.99,
        gumroadId: "credit-derivatives",
        featured: false,
        difficulty: "advanced",
        tags: ["credit derivatives","CDS","CDO","credit risk","structured credit"],
        prerequisites: [],
        category: "credit",
        tier: "professional",
      },
      {
        slug: "financial-statement-analysis",
        title: "Financial Statement Analysis",
        summary: 
          "Comprehensive guide to analyzing financial statements for credit analysis and investment decisions",
        duration: "25 min",
        price: 1.99,
        gumroadId: "financial-statement-analysis-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["financial-statements","credit-analysis","ratio-analysis","cash-flow","accounting"],
        prerequisites: [],
        category: "credit",
        tier: "professional",
      },
      {
        slug: "high-yield-debt",
        title: "High Yield & Distressed Debt",
        summary: "",
        duration: "25 min",
        price: 1.99,
        gumroadId: "high-yield-debt",
        featured: false,
        difficulty: "advanced",
        tags: ["high-yield","junk-bonds","distressed","restructuring","credit-analysis","leveraged-finance"],
        prerequisites: ["corporate-credit-analysis","credit-default-swaps"],
        category: "credit-instruments",
      },
      {
        slug: "trade-finance",
        title: "Trade Finance",
        summary: 
          "Comprehensive guide to trade finance instruments, documentary credits, and international payment mechanisms",
        duration: "20 min",
        price: 1.99,
        gumroadId: "trade-finance",
        featured: false,
        difficulty: "intermediate",
        tags: ["trade finance","letters of credit","documentary collections","export finance","supply chain"],
        prerequisites: [],
        category: "credit",
        tier: "essentials",
      },
    ],
  },
  {
    slug: "emerging-markets",
    title: "Emerging Markets",
    description: "",
    icon: "📚",
    color: "blue",
    category: "emerging-markets",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "emerging-market-currencies",
        title: "Emerging Market Currencies",
        summary: 
          "A comprehensive professional guide to emerging market currency analysis, trading strategies, and risk management covering exchange rate dynamics, monetary policy frameworks, and portfolio management",
        duration: "20 min",
        price: 1.99,
        gumroadId: "emerging-market-currencies-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["em-currencies","fx-markets","monetary-policy","risk-management","market-structure","institutional-trading"],
        prerequisites: ["introduction-to-fx","fx-forward-contracts"],
        category: "currencies",
        tier: "professional",
      },
      {
        slug: "emerging-market-debt",
        title: "Emerging Market Debt",
        summary: 
          "Comprehensive guide to emerging market debt analysis, sovereign and corporate credit, and portfolio management strategies",
        duration: "30 min",
        price: 1.99,
        gumroadId: "emerging-market-debt-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["em-debt","portfolio-management","credit-analysis","risk-assessment","sovereign"],
        prerequisites: ["bond-mathematics","government-bonds"],
        category: "debt",
        tier: "professional",
      },
      {
        slug: "emerging-market-equities",
        title: "Emerging Market Equities",
        summary: 
          "Comprehensive guide to emerging market equity analysis, valuation frameworks, and portfolio management strategies",
        duration: "25 min",
        price: 1.99,
        gumroadId: "emerging-market-equities-professional",
        featured: false,
        difficulty: "intermediate",
        tags: ["em-equities","portfolio-management","valuation","risk-assessment"],
        prerequisites: ["equity-futures-trading","equity-options-fundamentals"],
        category: "equities",
        tier: "professional",
      },
      {
        slug: "frontier-markets",
        title: "Frontier Markets",
        summary: 
          "Comprehensive guide to frontier market investing with Python implementations for risk analysis, country scoring, and portfolio construction",
        duration: "25 min",
        price: 1.99,
        gumroadId: "frontier-markets",
        featured: false,
        difficulty: "advanced",
        tags: ["frontier markets","emerging markets","investment","risk","portfolio","python"],
        prerequisites: ["emerging-market-debt"],
        category: "emerging-markets",
        tier: "professional",
        seriesOrder: 4,
      },
    ],
  },
  {
    slug: "equity-derivatives",
    title: "Equity Derivatives",
    description: "",
    icon: "📚",
    color: "blue",
    category: "equity-derivatives",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "equity-futures-trading",
        title: "Equity Index Futures",
        summary: 
          "Index futures mechanics, arbitrage strategies, and basis trading for equity derivatives",
        duration: "20 min",
        price: 1.99,
        gumroadId: "equity-futures-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["index-futures","arbitrage","basis-trading"],
        prerequisites: [],
        category: "derivatives",
        tier: "professional",
      },
      {
        slug: "equity-options-fundamentals",
        title: "Equity Options Fundamentals",
        summary: 
          "Options mechanics, pricing models, and basic strategies for equity derivatives",
        duration: "15 min",
        price: 1.99,
        gumroadId: "equity-options-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["equity-options","black-scholes","greeks","options-strategies"],
        prerequisites: [],
        category: "derivatives",
        tier: "professional",
      },
      {
        slug: "equity-swaps",
        title: "Equity Swaps & Total Return Swaps",
        summary: 
          "Equity swap mechanics, funding considerations, and institutional applications for synthetic equity exposure",
        duration: "25 min",
        price: 1.99,
        gumroadId: "equity-swaps-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["equity-swaps","total-return-swaps","funding"],
        prerequisites: [],
        category: "derivatives",
        tier: "expert",
      },
      {
        slug: "options-strategies",
        title: "Options Trading Strategies",
        summary: "",
        duration: "35 min",
        price: 1.99,
        gumroadId: "options-strategies",
        featured: false,
        difficulty: "advanced",
        tags: ["options","spreads","straddles","volatility","hedging","income-strategies"],
        prerequisites: ["equity-options-fundamentals"],
        category: "equity-derivatives",
      },
      {
        slug: "volatility-trading",
        title: "Volatility Trading Strategies",
        summary: 
          "Advanced volatility trading, VIX products, and dispersion trading strategies for equity markets",
        duration: "25 min",
        price: 1.99,
        gumroadId: "volatility-trading-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["volatility","vix","dispersion-trading"],
        prerequisites: [],
        category: "trading",
        tier: "expert",
      },
    ],
  },
  {
    slug: "fintech-innovation",
    title: "Fintech Innovation",
    description: "",
    icon: "📚",
    color: "blue",
    category: "fintech-innovation",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "api-integration",
        title: "API Integration & Data Analytics",
        summary: 
          "Financial APIs, data integration, and analytics platforms",
        duration: "30 min",
        price: 1.99,
        gumroadId: "api-integration",
        featured: false,
        difficulty: "advanced",
        tags: ["apis","data-integration","analytics"],
        prerequisites: [],
        category: "technology",
        tier: "expert",
      },
      {
        slug: "digital-payments",
        title: "Digital Payments & Banking",
        summary: 
          "Payment systems, digital wallets, and open banking frameworks",
        duration: "20 min",
        price: 1.99,
        gumroadId: "digital-payments-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["digital-payments","wallets","open-banking"],
        prerequisites: [],
        category: "payments",
        tier: "professional",
      },
      {
        slug: "open-banking",
        title: "Open Banking & API Economy",
        summary: 
          "Comprehensive guide to open banking frameworks, API standards, and financial services innovation",
        duration: "25 min",
        price: 1.99,
        gumroadId: "open-banking-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["open-banking","APIs","PSD2","fintech","banking-as-a-service"],
        prerequisites: ["digital-payments"],
        category: "technology",
        tier: "professional",
      },
      {
        slug: "postgresql-financial-systems",
        title: "PostgreSQL for Financial Systems",
        summary: 
          "Master PostgreSQL database design, optimization, and implementation for trading systems, risk management, and financial data analytics",
        duration: "30 min",
        price: 1.99,
        gumroadId: "postgresql-financial-systems",
        featured: false,
        difficulty: "advanced",
        tags: ["postgresql","database","SQL","fintech","data-management","trading-systems"],
        prerequisites: ["api-integration"],
        category: "fintech-innovation",
        tier: "expert",
      },
      {
        slug: "regtech-solutions",
        title: "RegTech & Compliance Technology",
        summary: 
          "Regulatory technology, automated compliance, and risk monitoring",
        duration: "40 min",
        price: 2.49,
        gumroadId: "regtech-solutions",
        featured: false,
        difficulty: "intermediate",
        tags: ["regtech","compliance-tech","risk-monitoring"],
        prerequisites: [],
        category: "compliance",
        tier: "professional",
      },
      {
        slug: "robo-advisors",
        title: "Robo-Advisors & Automated Investing",
        summary: 
          "Algorithmic portfolio management, robo-advisory platforms, and automation",
        duration: "35 min",
        price: 1.99,
        gumroadId: "robo-advisors",
        featured: false,
        difficulty: "intermediate",
        tags: ["robo-advisors","automated-investing","algorithms"],
        prerequisites: [],
        category: "automation",
        tier: "professional",
      },
    ],
  },
  {
    slug: "fixed-income-debt",
    title: "Fixed Income Debt",
    description: "",
    icon: "📚",
    color: "blue",
    category: "fixed-income-debt",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "corporate-bonds",
        title: "Corporate Bonds",
        summary: "",
        duration: "30 min",
        price: 1.99,
        gumroadId: "corporate-bonds",
        featured: false,
        difficulty: "intermediate",
        tags: ["corporate-bonds","credit","fixed-income","investment-grade","spreads"],
        prerequisites: ["bond-mathematics","government-bonds"],
        category: "fixed-income",
      },
      {
        slug: "em-debt-markets",
        title: "Emerging Market Debt",
        summary: 
          "A comprehensive professional guide to emerging market debt instruments, sovereign and corporate credit analysis, currency considerations, and investment strategies with real-world case studies",
        duration: "25 min",
        price: 1.99,
        gumroadId: "emerging-market-debt-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["em-debt","sovereign","local-currency","hard-currency","political-risk","credit-analysis","portfolio-construction"],
        prerequisites: ["bond-mathematics","government-bonds"],
        category: "debt",
        tier: "professional",
      },
      {
        slug: "government-bonds",
        title: "Government Bonds",
        summary: "",
        duration: "25 min",
        price: 1.99,
        gumroadId: "government-bonds",
        featured: false,
        difficulty: "intermediate",
        tags: ["government-bonds","treasuries","gilts","sovereign-debt","fixed-income","yield"],
        prerequisites: ["bond-mathematics"],
        category: "fixed-income",
      },
      {
        slug: "mortgage-backed-securities",
        title: "Mortgage-Backed Securities",
        summary: "",
        duration: "40 min",
        price: 1.99,
        gumroadId: "mortgage-backed-securities",
        featured: false,
        difficulty: "advanced",
        tags: ["mbs","prepayment","securitization","agency","structured-finance","convexity"],
        prerequisites: ["bond-mathematics","yield-curves-fundamentals"],
        category: "fixed-income",
      },
      {
        slug: "municipal-bonds",
        title: "Municipal Bonds",
        summary: 
          "Tax-exempt municipal securities, credit analysis, and investment strategies",
        duration: "15 min",
        price: 1.99,
        gumroadId: "municipal-bonds-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["municipal-bonds","tax-exempt","credit-analysis","public-finance"],
        prerequisites: ["government-bonds"],
        category: "bonds",
        tier: "professional",
      },
      {
        slug: "sovereign-debt",
        title: "Sovereign Debt Analysis",
        summary: 
          "Sovereign bond markets, country risk assessment, and emerging market debt",
        duration: "20 min",
        price: 1.99,
        gumroadId: "sovereign-debt-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["sovereign-debt","country-risk","emerging-markets","government-bonds"],
        prerequisites: ["government-bonds"],
        category: "bonds",
        tier: "professional",
      },
    ],
  },
  {
    slug: "fx-instruments",
    title: "Fx Instruments",
    description: "",
    icon: "📚",
    color: "blue",
    category: "fx-instruments",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "ccswaps",
        title: "Cross-Currency Swaps",
        summary: 
          "Master cross-currency swap mechanics, valuation frameworks, trading strategies, and risk management for institutional treasury and trading operations",
        duration: "35 min",
        price: 1.99,
        gumroadId: "ccswaps-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["cross-currency","swaps","derivatives","fx","hedging","basis-trading"],
        prerequisites: ["interest-rate-swaps","fx-forward-contracts"],
        category: "derivatives",
        tier: "professional",
      },
      {
        slug: "em-fx-markets",
        title: "Emerging Market FX",
        summary: 
          "Comprehensive guide to emerging market currency dynamics, trading strategies, intervention policies, and risk management",
        duration: "45 min",
        price: 2.49,
        gumroadId: "emerging-market-fx-professional",
        featured: false,
        difficulty: "advanced",
        tags: ["em-fx","carry-trades","intervention","currency-dynamics","political-risk"],
        prerequisites: ["spot-fx-trading","fx-forward-contracts"],
        category: "fx",
        tier: "professional",
      },
      {
        slug: "fx-forward-contracts",
        title: "FX Forward Contracts",
        summary: 
          "Deep dive into FX forwards - pricing models, hedge accounting, settlement mechanics, and strategic applications for corporate treasury and risk management",
        duration: "55 min",
        price: 2.49,
        gumroadId: "fx-forwards-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["forwards","hedging","pricing","settlement","corporate-treasury"],
        prerequisites: ["introduction-to-fx","spot-fx-trading"],
        category: "hedging",
        tier: "professional",
      },
      {
        slug: "fx-options",
        title: "FX Options: Advanced Risk Management",
        summary: 
          "Master FX options from vanilla strategies to exotic structures. Covers volatility trading, option pricing models, and sophisticated hedging techniques",
        duration: "25 min",
        price: 1.99,
        gumroadId: "fx-options-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["options","volatility","hedging","exotic","structured-products"],
        prerequisites: ["introduction-to-fx","spot-fx-trading","fx-forward-contracts"],
        category: "options",
        tier: "expert",
      },
      {
        slug: "fx-swaps",
        title: "FX Swaps: Funding and Liquidity Tools",
        summary: 
          "Understand FX swaps mechanics, funding applications, central bank operations, and their critical role in global liquidity management",
        duration: "30 min",
        price: 1.99,
        gumroadId: "fx-swaps-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["swaps","funding","liquidity","central-banks","operations"],
        prerequisites: ["introduction-to-fx","spot-fx-trading"],
        category: "funding",
        tier: "professional",
      },
      {
        slug: "introduction-to-fx",
        title: "Introduction to Foreign Exchange (FX): A Professional Guide",
        summary: 
          "Master the fundamentals of global FX markets including market structure, currency analysis, risk management, and quantitative techniques with practical Python implementations",
        duration: "35 min",
        price: 1.99,
        gumroadId: "fx-fundamentals-pro",
        featured: false,
        difficulty: "beginner",
        tags: ["fx-basics","market-overview","fundamentals","currency","quotes","market-structure","risk-management","python-implementation"],
        prerequisites: [],
        category: "fundamentals",
        tier: "professional",
      },
      {
        slug: "spot-fx-trading",
        title: "Spot FX Trading Fundamentals",
        summary: 
          "Master spot foreign exchange markets with comprehensive insights on market structure, pricing mechanisms, execution strategies, and risk management",
        duration: "25 min",
        price: 0,
        gumroadId: "spot-fx-manual",
        featured: true,
        difficulty: "beginner",
        tags: ["spot","execution","pricing","settlement","fx-trading"],
        prerequisites: ["introduction-to-fx"],
        category: "fx-instruments",
        tier: "foundation",
        free: true,
      },
    ],
  },
  {
    slug: "fx-markets",
    title: "Fx Markets",
    description: "",
    icon: "📚",
    color: "blue",
    category: "fx-markets",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "fx-market-participants",
        title: "FX Market Participants",
        summary: 
          "Comprehensive guide to FX market participants with Python implementations for flow analysis and participant behavior modeling",
        duration: "25 min",
        price: 1.99,
        gumroadId: "fx-market-participants",
        featured: false,
        difficulty: "intermediate",
        tags: ["fx","market participants","banks","corporates","hedge funds","central banks","python"],
        prerequisites: ["fx-market-structure"],
        category: "fx-markets",
        tier: "essentials",
        seriesOrder: 2,
      },
      {
        slug: "fx-market-structure",
        title: "FX Market Structure",
        summary: 
          "Comprehensive guide to global FX market structure, trading venues, and market organization",
        duration: "25 min",
        price: 1.99,
        gumroadId: "fx-market-structure",
        featured: false,
        difficulty: "intermediate",
        tags: ["fx","market structure","trading","venues","otc","ecn"],
        prerequisites: [],
        category: "fx",
        tier: "essentials",
      },
      {
        slug: "global-fx-centers",
        title: "Global FX Centers",
        summary: 
          "Comprehensive guide to the world's major foreign exchange trading centers and their roles in 24-hour markets",
        duration: "20 min",
        price: 1.99,
        gumroadId: "global-fx-centers",
        featured: false,
        difficulty: "intermediate",
        tags: ["fx","trading centers","london","new york","tokyo","singapore","time zones"],
        prerequisites: [],
        category: "fx",
        tier: "essentials",
      },
    ],
  },
  {
    slug: "interest-rates",
    title: "Interest Rates",
    description: "",
    icon: "📚",
    color: "blue",
    category: "interest-rates",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "bond-mathematics",
        title: "Bond Mathematics",
        summary: 
          "Master bond pricing, yield calculations, duration, and convexity for fixed income analysis",
        duration: "25 min",
        price: 1.99,
        gumroadId: "bond-mathematics-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["bond-pricing","duration","convexity","yield-calculations"],
        prerequisites: [],
        category: "analytics",
        tier: "professional",
      },
      {
        slug: "curve-trading-strategies",
        title: "Curve Trading Strategies",
        summary: 
          "Advanced yield curve positioning, steepeners, flatteners, and butterfly trades",
        duration: "25 min",
        price: 1.99,
        gumroadId: "curve-trading-strategies-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["yield-curve","steepener","flattener","butterfly","curve-trading"],
        prerequisites: ["yield-curves-fundamentals","bond-mathematics"],
        category: "trading",
        tier: "expert",
      },
      {
        slug: "fras",
        title: "Forward Rate Agreements",
        summary: 
          "Complete guide to FRA mechanics, pricing formulas, hedging applications, and trading strategies for interest rate risk management",
        duration: "30 min",
        price: 1.99,
        gumroadId: "fras-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["forwards","rates","derivatives","hedging","libor","sofr"],
        prerequisites: ["bond-mathematics","yield-curves-fundamentals"],
        category: "rates",
        tier: "professional",
      },
      {
        slug: "interest-rate-swaps",
        title: "Interest Rate Swaps",
        summary: "",
        duration: "35 min",
        price: 1.99,
        gumroadId: "interest-rate-swaps",
        featured: false,
        difficulty: "intermediate",
        tags: ["swaps","interest-rates","derivatives","hedging","fixed-income","OTC"],
        prerequisites: ["bond-mathematics","yield-curves-fundamentals"],
        category: "interest-rates",
      },
      {
        slug: "swaptions-caps-floors",
        title: "Swaptions, Caps & Floors",
        summary: "",
        duration: "20 min",
        price: 1.99,
        gumroadId: "swaptions-caps-floors",
        featured: false,
        difficulty: "advanced",
        tags: ["swaptions","caps","floors","interest-rate-options","derivatives","hedging"],
        prerequisites: ["interest-rate-swaps","options-fundamentals"],
        category: "interest-rates",
      },
      {
        slug: "yield-curves-fundamentals",
        title: "Yield Curves Fundamentals",
        summary: "",
        duration: "25 min",
        price: 1.99,
        gumroadId: "yield-curves-fundamentals",
        featured: false,
        difficulty: "intermediate",
        tags: ["yield-curve","fixed-income","interest-rates","bootstrapping","term-structure"],
        prerequisites: ["bond-mathematics"],
        category: "interest-rates",
      },
    ],
  },
  {
    slug: "islamic-finance",
    title: "Islamic Finance",
    description: "",
    icon: "📚",
    color: "blue",
    category: "islamic-finance",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "islamic-banking",
        title: "Islamic Banking Operations",
        summary: 
          "Comprehensive guide to Murabaha, Ijara, Musharaka, and Islamic banking products with Python implementations",
        duration: "25 min",
        price: 1.99,
        gumroadId: "islamic-banking",
        featured: false,
        difficulty: "intermediate",
        tags: ["islamic-banking","murabaha","ijara","musharaka","sharia-compliant"],
        prerequisites: ["sharia-principles"],
        category: "islamic-finance",
        tier: "professional",
        seriesOrder: 2,
      },
      {
        slug: "sharia-principles",
        title: "Sharia Principles in Finance",
        summary: 
          "Islamic law foundations, prohibited elements, and compliance frameworks",
        duration: "25 min",
        price: 1.99,
        gumroadId: "sharia-principles-manual",
        featured: false,
        difficulty: "beginner",
        tags: ["sharia","islamic-law","compliance","principles"],
        prerequisites: [],
        category: "fundamentals",
        tier: "foundation",
      },
      {
        slug: "sukuk-markets",
        title: "Sukuk Markets",
        summary: "",
        duration: "20 min",
        price: 1.99,
        gumroadId: "sukuk-markets",
        featured: false,
        difficulty: "intermediate",
        tags: ["sukuk","islamic-finance","sharia","bonds","fixed-income"],
        prerequisites: ["bond-mathematics","sharia-principles"],
        category: "islamic-finance",
      },
      {
        slug: "takaful-insurance",
        title: "Takaful & Islamic Insurance",
        summary: 
          "Comprehensive guide to Islamic insurance principles, takaful structures, and actuarial frameworks with Python implementations",
        duration: "20 min",
        price: 1.99,
        gumroadId: "takaful-insurance",
        featured: false,
        difficulty: "intermediate",
        tags: ["takaful","islamic-insurance","risk-management","wakala","mudaraba"],
        prerequisites: ["sharia-principles"],
        category: "islamic-finance",
        tier: "professional",
        seriesOrder: 4,
      },
    ],
  },
  {
    slug: "liquidity-funding",
    title: "Liquidity Funding",
    description: "",
    icon: "📚",
    color: "blue",
    category: "liquidity-funding",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "cash-flow-management",
        title: "Cash Flow Management",
        summary: 
          "Advanced cash flow forecasting, optimization, and working capital management strategies",
        duration: "15 min",
        price: 1.99,
        gumroadId: "cash-flow-management-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["cash-flow","forecasting","working-capital","treasury"],
        prerequisites: [],
        category: "operations",
        tier: "professional",
      },
      {
        slug: "intraday-liquidity",
        title: "Intraday Liquidity",
        summary: 
          "Comprehensive guide to intraday liquidity management with Python implementations for monitoring, stress testing, and optimization",
        duration: "25 min",
        price: 1.99,
        gumroadId: "intraday-liquidity",
        featured: false,
        difficulty: "intermediate",
        tags: ["intraday","liquidity","payments","RTGS","nostro","treasury","python"],
        prerequisites: ["liquidity-coverage-ratio"],
        category: "liquidity-funding",
        tier: "professional",
        seriesOrder: 3,
      },
      {
        slug: "funding-optimization",
        title: "Liquidity Funding Management",
        summary: 
          "Strategic liquidity management, funding optimization, and regulatory compliance frameworks",
        duration: "20 min",
        price: 1.99,
        gumroadId: "liquidity-funding-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["liquidity","funding","alm","regulatory"],
        prerequisites: [],
        category: "risk",
        tier: "professional",
      },
      {
        slug: "liquidity-management",
        title: "Liquidity Risk Management",
        summary: 
          "Funding liquidity, market liquidity, and regulatory requirements",
        duration: "25 min",
        price: 1.99,
        gumroadId: "liquidity-risk-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["liquidity-risk","funding","lcr","nsfr"],
        prerequisites: [],
        category: "risk",
        tier: "professional",
      },
    ],
  },
  {
    slug: "money-markets",
    title: "Money Markets",
    description: "",
    icon: "📚",
    color: "blue",
    category: "money-markets",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "call-accounts",
        title: "Call Accounts",
        summary: 
          "Professional finance manual covering call accounts",
        duration: "35 min",
        price: 1.99,
        gumroadId: "call-accounts",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "certificates-deposit",
        title: "Certificates Deposit",
        summary: 
          "Professional finance manual covering certificates deposit",
        duration: "60 min",
        price: 2.49,
        gumroadId: "certificates-deposit",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "commercial-paper",
        title: "Commercial Paper",
        summary: 
          "Professional finance manual covering commercial paper",
        duration: "75 min",
        price: 2.49,
        gumroadId: "commercial-paper",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "repos-reverse-repos",
        title: "Repos Reverse Repos",
        summary: 
          "Professional finance manual covering repos reverse repos",
        duration: "30 min",
        price: 1.99,
        gumroadId: "repos-reverse-repos",
        featured: false,
        difficulty: "intermediate",
        tags: ["finance","professional"],
        prerequisites: [],
      },
      {
        slug: "securities-lending",
        title: "Securities Lending & Repo Markets",
        summary: 
          "Comprehensive guide to securities lending, repo transactions, and financing market mechanics",
        duration: "25 min",
        price: 1.99,
        gumroadId: "securities-lending-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["securities-lending","repo","financing","collateral","prime-brokerage"],
        prerequisites: ["repos-reverse-repos"],
        category: "money-markets",
        tier: "expert",
      },
    ],
  },
  {
    slug: "portfolio-management",
    title: "Portfolio Management",
    description: "",
    icon: "📚",
    color: "blue",
    category: "portfolio-management",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "alternative-investments",
        title: "Alternative Investments",
        summary: 
          "Hedge funds, private equity, real estate, and infrastructure investing strategies and analysis",
        duration: "20 min",
        price: 1.99,
        gumroadId: "alternatives-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["alternatives","hedge-funds","private-equity","real-estate"],
        prerequisites: [],
        category: "strategy",
        tier: "expert",
      },
      {
        slug: "asset-allocation",
        title: "Asset Allocation Strategies",
        summary: "",
        duration: "55 min",
        price: 2.49,
        gumroadId: "asset-allocation",
        featured: false,
        difficulty: "advanced",
        tags: ["asset-allocation","strategic","tactical","risk-parity","multi-asset","rebalancing"],
        prerequisites: ["modern-portfolio-theory"],
        category: "portfolio-management",
      },
      {
        slug: "esg-investing",
        title: "ESG & Sustainable Investing",
        summary: 
          "Comprehensive guide to environmental, social, and governance investing strategies and integration",
        duration: "25 min",
        price: 0,
        gumroadId: "esg-investing-manual",
        featured: true,
        difficulty: "intermediate",
        tags: ["ESG","sustainable-investing","green-bonds","impact-investing","carbon-markets"],
        prerequisites: ["modern-portfolio-theory"],
        category: "portfolio-management",
        tier: "professional",
        free: true,
      },
      {
        slug: "factor-investing",
        title: "Factor Investing & Smart Beta Strategies",
        summary: 
          "Comprehensive guide to factor models, smart beta implementation, and multi-factor portfolio construction for institutional investors",
        duration: "35 min",
        price: 1.99,
        gumroadId: "factor-investing-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["factor-investing","smart-beta","multi-factor","fama-french","risk-premia","systematic-strategies"],
        prerequisites: [],
      },
      {
        slug: "hedge-fund-strategies",
        title: "Hedge Fund Strategies",
        summary: "",
        duration: "80 min",
        price: 2.49,
        gumroadId: "hedge-fund-strategies",
        featured: false,
        difficulty: "advanced",
        tags: ["hedge-funds","alternative-investments","long-short","global-macro","event-driven","alpha"],
        prerequisites: ["modern-portfolio-theory","factor-investing"],
        category: "portfolio-management",
      },
      {
        slug: "modern-portfolio-theory",
        title: "Modern Portfolio Theory & Optimization",
        summary: 
          "Comprehensive guide to Markowitz portfolio theory, efficient frontier construction, and practical portfolio optimization techniques for financial professionals",
        duration: "40 min",
        price: 2.49,
        gumroadId: "modern-portfolio-theory-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["portfolio","optimization","markowitz","efficient-frontier","risk","return","capm","diversification"],
        prerequisites: [],
      },
      {
        slug: "pension-management",
        title: "Pension Fund Management",
        summary: "",
        duration: "30 min",
        price: 1.99,
        gumroadId: "pension-management",
        featured: false,
        difficulty: "advanced",
        tags: ["pensions","ldi","defined-benefit","defined-contribution","fiduciary","longevity-risk"],
        prerequisites: ["asset-allocation","fixed-income-fundamentals"],
        category: "portfolio-management",
      },
      {
        slug: "performance-attribution",
        title: "Performance Attribution & Measurement",
        summary: 
          "Performance analysis, attribution models, and risk-adjusted return calculations for institutional portfolios",
        duration: "20 min",
        price: 1.99,
        gumroadId: "performance-attribution-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["performance","attribution","risk-adjusted-returns"],
        prerequisites: [],
        category: "analytics",
        tier: "professional",
      },
      {
        slug: "private-equity",
        title: "Private Equity & Venture Capital",
        summary: 
          "Comprehensive guide to private equity investing, fund structures, and value creation strategies",
        duration: "25 min",
        price: 1.99,
        gumroadId: "private-equity-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["private-equity","venture-capital","leveraged-buyout","fund-structure","due-diligence"],
        prerequisites: ["alternative-investments"],
        category: "portfolio-management",
        tier: "expert",
      },
      {
        slug: "railway-infrastructure-finance",
        title: "Railway Infrastructure Finance",
        summary: 
          "Comprehensive guide to railway infrastructure investment, rail bonds, public-private partnerships, and transport infrastructure portfolio analysis",
        duration: "25 min",
        price: 1.99,
        gumroadId: "railway-infrastructure-finance",
        featured: false,
        difficulty: "advanced",
        tags: ["infrastructure","railway","bonds","PPP","transport","project-finance"],
        prerequisites: ["alternative-investments"],
        category: "portfolio-management",
        tier: "expert",
      },
      {
        slug: "real-estate-investment",
        title: "Real Estate Investment",
        summary: 
          "Comprehensive guide to real estate investment trusts, property derivatives, and real estate portfolio management",
        duration: "25 min",
        price: 1.99,
        gumroadId: "real-estate-investment-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["real-estate","REITs","property","commercial-real-estate","property-derivatives"],
        prerequisites: ["alternative-investments"],
        category: "portfolio-management",
        tier: "expert",
      },
      {
        slug: "wealth-management",
        title: "Wealth Management & Family Offices",
        summary: 
          "Comprehensive guide to high net worth wealth management, family office operations, and multi-generational planning",
        duration: "25 min",
        price: 1.99,
        gumroadId: "wealth-management-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["wealth-management","family-office","estate-planning","UHNW","trust-structures"],
        prerequisites: ["modern-portfolio-theory","alternative-investments"],
        category: "portfolio-management",
        tier: "expert",
      },
    ],
  },
  {
    slug: "quantitative-methods",
    title: "Quantitative Methods",
    description: "",
    icon: "📚",
    color: "blue",
    category: "quantitative-methods",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "behavioral-finance",
        title: "Behavioral Finance",
        summary: "",
        duration: "50 min",
        price: 2.49,
        gumroadId: "behavioral-finance",
        featured: false,
        difficulty: "intermediate",
        tags: ["behavioral-finance","psychology","biases","anomalies","investor-behavior","market-efficiency"],
        prerequisites: [],
        category: "quantitative-methods",
      },
      {
        slug: "derivatives-valuation",
        title: "Derivatives Valuation & Pricing Theory",
        summary: "",
        duration: "30 min",
        price: 1.99,
        gumroadId: "derivatives-valuation",
        featured: false,
        difficulty: "advanced",
        tags: ["derivatives","black-scholes","binomial-model","pricing","risk-neutral","greeks"],
        prerequisites: ["stochastic-calculus"],
        category: "quantitative-methods",
      },
      {
        slug: "machine-learning-finance",
        title: "Machine Learning in Finance",
        summary: 
          "Comprehensive guide to implementing machine learning in institutional finance, covering advanced trading strategies, risk management, and portfolio optimisation with real-world applications from leading financial institutions",
        duration: "35 min",
        price: 1.99,
        gumroadId: "ml-finance-manual",
        featured: true,
        difficulty: "advanced",
        tags: ["machine-learning","ai","algorithmic-trading","risk-management","portfolio-optimisation","quantitative-finance"],
        prerequisites: ["quantitative-methods/stochastic-calculus","quantitative-methods/numerical-methods"],
        category: "technology",
        tier: "expert",
      },
      {
        slug: "monte-carlo-methods",
        title: "Monte Carlo Methods",
        summary: 
          "Simulation techniques, variance reduction methods, and pricing applications in financial modeling",
        duration: "25 min",
        price: 1.99,
        gumroadId: "monte-carlo-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["monte-carlo","simulation","variance-reduction"],
        prerequisites: [],
        category: "mathematics",
        tier: "expert",
      },
      {
        slug: "numerical-methods",
        title: "Numerical Methods in Finance",
        summary: 
          "Finite difference methods, tree models, and PDE solutions for derivatives pricing and risk management",
        duration: "20 min",
        price: 1.99,
        gumroadId: "numerical-methods-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["numerical-methods","finite-difference","pde"],
        prerequisites: [],
        category: "mathematics",
        tier: "expert",
      },
      {
        slug: "stochastic-calculus",
        title: "Stochastic Calculus for Finance",
        summary: 
          "Brownian motion, Ito calculus, and stochastic differential equations",
        duration: "15 min",
        price: 1.99,
        gumroadId: "stochastic-calculus-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["stochastic-calculus","brownian-motion","ito-calculus","sde"],
        prerequisites: [],
        category: "mathematics",
        tier: "expert",
      },
    ],
  },
  {
    slug: "regulation-compliance",
    title: "Regulation Compliance",
    description: "",
    icon: "📚",
    color: "blue",
    category: "regulation-compliance",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "basel-framework",
        title: "Basel III/IV Framework",
        summary: 
          "Capital requirements, liquidity ratios, and risk-weighted assets under the Basel regulatory framework",
        duration: "30 min",
        price: 1.99,
        gumroadId: "basel-framework-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["basel","capital-requirements","liquidity","rwa"],
        prerequisites: [],
        category: "banking-regulation",
        tier: "professional",
      },
      {
        slug: "conduct-market-abuse",
        title: "Conduct & Market Abuse",
        summary: 
          "Comprehensive guide to market abuse regulations with Python implementations for surveillance, detection, and compliance monitoring",
        duration: "20 min",
        price: 1.99,
        gumroadId: "conduct-market-abuse",
        featured: false,
        difficulty: "intermediate",
        tags: ["market abuse","MAR","insider trading","manipulation","conduct","compliance","python"],
        prerequisites: ["regulatory-framework"],
        category: "regulation-compliance",
        tier: "professional",
        seriesOrder: 4,
      },
      {
        slug: "emir-reporting",
        title: "EMIR Reporting",
        summary: 
          "Comprehensive guide to EMIR derivative reporting requirements, trade repositories, and regulatory compliance",
        duration: "15 min",
        price: 1.99,
        gumroadId: "emir-reporting",
        featured: false,
        difficulty: "intermediate",
        tags: ["EMIR","derivatives","reporting","trade repository","regulatory","compliance"],
        prerequisites: [],
        category: "compliance",
        tier: "professional",
      },
      {
        slug: "kyc-aml-compliance",
        title: "KYC/AML Compliance",
        summary: 
          "Comprehensive guide to Know Your Customer, Anti-Money Laundering, and financial crime compliance frameworks",
        duration: "20 min",
        price: 1.99,
        gumroadId: "kyc-aml-compliance",
        featured: false,
        difficulty: "intermediate",
        tags: ["KYC","AML","compliance","financial crime","sanctions","due diligence"],
        prerequisites: [],
        category: "compliance",
        tier: "professional",
      },
      {
        slug: "mifid-dodd-frank",
        title: "MiFID II & Dodd-Frank",
        summary: 
          "Trading regulations, transparency requirements, and derivatives markets under MiFID II and Dodd-Frank",
        duration: "20 min",
        price: 1.99,
        gumroadId: "mifid-dodd-frank-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["mifid","dodd-frank","transparency","derivatives-regulation"],
        prerequisites: [],
        category: "trading-regulation",
        tier: "professional",
      },
    ],
  },
  {
    slug: "risk-management",
    title: "Risk Management",
    description: "",
    icon: "📚",
    color: "blue",
    category: "risk-management",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "collateral-management",
        title: "Collateral Management Systems",
        summary: 
          "End-to-end collateral lifecycle, optimization, and operational frameworks",
        duration: "15 min",
        price: 1.99,
        gumroadId: "collateral-management-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["collateral","margining","operations"],
        prerequisites: [],
        category: "risk",
        tier: "expert",
      },
      {
        slug: "credit-risk-modeling",
        title: "Credit Risk Modeling",
        summary: 
          "PD, LGD, EAD modeling and credit portfolio risk management",
        duration: "10 min",
        price: 0.99,
        gumroadId: "credit-risk-modeling-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["credit-modeling","pd","lgd","ead","portfolio-risk"],
        prerequisites: ["market-risk-fundamentals"],
        category: "risk",
        tier: "expert",
      },
      {
        slug: "liquidity-risk",
        title: "Liquidity Risk Management",
        summary: 
          "Funding liquidity, market liquidity, and regulatory requirements",
        duration: "10 min",
        price: 0.99,
        gumroadId: "liquidity-risk-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["liquidity-risk","funding","lcr","nsfr"],
        prerequisites: [],
        category: "risk",
        tier: "professional",
      },
      {
        slug: "market-risk-fundamentals",
        title: "Market Risk Fundamentals",
        summary: 
          "Comprehensive guide to market risk measurement, VaR modeling, Expected Shortfall, and institutional risk management frameworks",
        duration: "85 min",
        price: 2.49,
        gumroadId: "market-risk-fundamentals-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["market-risk","var","expected-shortfall","risk-modeling","basel-framework","stress-testing"],
        prerequisites: [],
      },
      {
        slug: "model-validation",
        title: "Model Validation & Model Risk",
        summary: 
          "Comprehensive guide to model risk management, validation frameworks, and governance",
        duration: "25 min",
        price: 1.99,
        gumroadId: "model-validation-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["model-risk","validation","governance","SR-11-7","model-lifecycle"],
        prerequisites: ["market-risk-fundamentals","credit-risk-modeling"],
        category: "risk-management",
        tier: "expert",
      },
      {
        slug: "operational-risk",
        title: "Operational Risk Management",
        summary: 
          "Comprehensive guide to operational risk frameworks, Basel III requirements, loss modeling, and institutional risk management practices",
        duration: "85 min",
        price: 2.49,
        gumroadId: "operational-risk-manual",
        featured: false,
        difficulty: "intermediate",
        tags: ["operational-risk","basel-iii","loss-modeling","risk-frameworks","business-continuity","cyber-risk"],
        prerequisites: [],
      },
      {
        slug: "stress-testing",
        title: "Stress Testing & Scenario Analysis",
        summary: 
          "Comprehensive guide to regulatory stress testing, scenario design, and capital planning",
        duration: "30 min",
        price: 1.99,
        gumroadId: "stress-testing-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["stress-testing","CCAR","DFAST","scenario-analysis","capital-planning"],
        prerequisites: ["market-risk-fundamentals","credit-risk-modeling"],
        category: "risk-management",
        tier: "expert",
      },
      {
        slug: "xva-framework",
        title: "XVA Framework & Counterparty Risk",
        summary: 
          "Comprehensive guide to CVA, DVA, FVA, and XVA management for derivatives portfolios",
        duration: "25 min",
        price: 1.99,
        gumroadId: "xva-framework-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["XVA","CVA","DVA","FVA","counterparty-risk","derivatives","pricing"],
        prerequisites: ["credit-risk-modeling","interest-rate-swaps"],
        category: "risk-management",
        tier: "expert",
      },
    ],
  },
  {
    slug: "structured-products",
    title: "Structured Products",
    description: "",
    icon: "📚",
    color: "blue",
    category: "structured-products",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "convertible-bonds",
        title: "Convertible Bonds",
        summary: 
          "Convertible bond analysis, pricing models, and hedging strategies for hybrid securities",
        duration: "25 min",
        price: 1.99,
        gumroadId: "convertibles-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["convertibles","hybrid-securities","delta-hedging"],
        prerequisites: [],
        category: "hybrid-securities",
        tier: "expert",
      },
      {
        slug: "exotic-derivatives",
        title: "Exotic Derivatives",
        summary: 
          "Path-dependent options, multi-asset derivatives, and complex payoffs",
        duration: "30 min",
        price: 1.99,
        gumroadId: "exotic-derivatives",
        featured: false,
        difficulty: "advanced",
        tags: ["exotic-derivatives","path-dependent","multi-asset"],
        prerequisites: [],
        category: "derivatives",
        tier: "expert",
      },
      {
        slug: "hybrid-instruments",
        title: "Hybrid Instruments",
        summary: 
          "Contingent convertibles, preferred shares, and regulatory capital instruments",
        duration: "40 min",
        price: 1.99,
        gumroadId: "hybrid-instruments",
        featured: false,
        difficulty: "advanced",
        tags: ["hybrids","cocos","preferred-shares","regulatory-capital"],
        prerequisites: [],
        category: "regulatory",
        tier: "expert",
      },
      {
        slug: "structured-credit",
        title: "Structured Credit Products",
        summary: "",
        duration: "25 min",
        price: 1.99,
        gumroadId: "structured-credit",
        featured: false,
        difficulty: "advanced",
        tags: ["clo","abs","rmbs","securitization","tranching","credit-enhancement"],
        prerequisites: ["corporate-credit-analysis","bond-mathematics"],
        category: "structured-products",
      },
      {
        slug: "structured-notes",
        title: "Structured Notes & Capital Protection",
        summary: 
          "Principal-protected notes, barrier structures, and payoff design for structured investment products",
        duration: "20 min",
        price: 1.99,
        gumroadId: "structured-notes-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["structured-notes","capital-protection","barriers"],
        prerequisites: [],
        category: "structured-products",
        tier: "expert",
      },
    ],
  },
  {
    slug: "treasury-systems",
    title: "Treasury Systems",
    description: "",
    icon: "📚",
    color: "blue",
    category: "treasury-systems",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "corporate-treasury",
        title: "Corporate Treasury Management",
        summary: 
          "Comprehensive guide to corporate treasury with Python implementations for cash management, working capital optimization, and financial risk hedging",
        duration: "25 min",
        price: 1.99,
        gumroadId: "corporate-treasury",
        featured: false,
        difficulty: "advanced",
        tags: ["treasury","cash-management","working-capital","fx-risk","interest-rate-risk","corporate-finance","python"],
        prerequisites: [],
        category: "treasury-systems",
        seriesOrder: 1,
      },
      {
        slug: "payment-systems",
        title: "Payment Systems",
        summary: 
          "Comprehensive guide to global payment systems, clearing mechanisms, and modern payment infrastructure",
        duration: "20 min",
        price: 1.99,
        gumroadId: "payment-systems",
        featured: false,
        difficulty: "intermediate",
        tags: ["payments","SWIFT","clearing","real-time payments","correspondent banking"],
        prerequisites: [],
        category: "treasury",
        tier: "professional",
      },
      {
        slug: "risk-systems",
        title: "Risk Management Systems",
        summary: 
          "Real-time risk systems, position management, and automated controls for financial institutions",
        duration: "20 min",
        price: 1.99,
        gumroadId: "risk-systems-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["risk-systems","real-time","controls"],
        prerequisites: [],
        category: "technology",
        tier: "expert",
      },
      {
        slug: "settlement-systems",
        title: "Settlement Systems",
        summary: 
          "Comprehensive guide to securities settlement with Python implementations for DVP analysis, fail management, and settlement optimization",
        duration: "15 min",
        price: 1.99,
        gumroadId: "settlement-systems",
        featured: false,
        difficulty: "intermediate",
        tags: ["settlement","CSD","clearing","T+1","custody","post-trade","python"],
        prerequisites: ["corporate-treasury"],
        category: "treasury-systems",
        tier: "professional",
        seriesOrder: 3,
      },
      {
        slug: "trading-systems",
        title: "Trading Systems & Platforms",
        summary: 
          "Electronic trading infrastructure with Python implementations for order management, execution algorithms, and performance analytics",
        duration: "15 min",
        price: 1.99,
        gumroadId: "trading-systems-manual",
        featured: false,
        difficulty: "advanced",
        tags: ["trading-systems","oms","execution","electronic-trading","algorithms","python"],
        prerequisites: ["corporate-treasury"],
        category: "treasury-systems",
        tier: "expert",
        seriesOrder: 4,
      },
      {
        slug: "treasury-technology",
        title: "Treasury Technology",
        summary: "",
        duration: "30 min",
        price: 1.99,
        gumroadId: "treasury-technology",
        featured: false,
        difficulty: "intermediate",
        tags: ["treasury","technology","TMS","automation","digital-transformation","systems"],
        prerequisites: ["corporate-treasury"],
        category: "treasury-systems",
      },
    ],
  },
  {
    slug: "commodities-energy",
    title: "Commodities Energy",
    description: "",
    icon: "📚",
    color: "blue",
    category: "commodities-energy",
    difficulty: "intermediate",
    manuals: [
      {
        slug: "why-commodity-energy-matter",
        title: "Why Commodity and Energy Markets Matter",
        summary: 
          "What distinguishes commodities from financial assets; spot, forward, futures, and options; physical vs financial settlement; benchmarks and basis",
        duration: "15 min",
        price: 0,
        gumroadId: "why-commodity-energy-matter",
        featured: false,
        difficulty: "intermediate",
        tags: ["commodities","energy","foundations","benchmarks","basis"],
        prerequisites: [],
        category: "commodities-energy",
        tier: "professional",
        free: true,
        seriesOrder: 1,
      },
      {
        slug: "commodity-market-structure",
        title: "Commodity Market Structure and Participants",
        summary: 
          "Producers, processors, merchants, utilities; exchanges, OTC, brokers, clearing; commercial hedgers vs speculative participants; price discovery",
        duration: "10 min",
        price: 0.99,
        gumroadId: "commodity-market-structure",
        featured: false,
        difficulty: "intermediate",
        tags: ["commodities","market-structure","participants","exchanges","OTC"],
        prerequisites: ["why-commodity-energy-matter"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 2,
      },
      {
        slug: "benchmarking-basis-pricing",
        title: "Benchmarking, Basis, and the Language of Commodity Pricing",
        summary: 
          "Location, quality, time, and currency basis; benchmark design and benchmark fragility in commodity markets",
        duration: "15 min",
        price: 1.99,
        gumroadId: "benchmarking-basis-pricing",
        featured: false,
        difficulty: "intermediate",
        tags: ["commodities","basis","benchmarks","pricing","location"],
        prerequisites: ["why-commodity-energy-matter"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 3,
      },
      {
        slug: "geopolitical-risk-energy",
        title: "Geopolitical Risk in Energy Markets",
        summary: 
          "Supply shocks, sanctions, conflict; OPEC and producer politics; energy security and price volatility",
        duration: "20 min",
        price: 1.99,
        gumroadId: "geopolitical-risk-energy",
        featured: false,
        difficulty: "intermediate",
        tags: ["geopolitics","OPEC","sanctions","energy-security","volatility"],
        prerequisites: ["why-commodity-energy-matter"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 4,
      },
      {
        slug: "historical-cycles-oil",
        title: "Historical Cycles in Oil Markets",
        summary: 
          "Boom-bust cycles, demand and supply elasticity; lessons from 2008, 2014–2016, 2020",
        duration: "15 min",
        price: 1.99,
        gumroadId: "historical-cycles-oil",
        featured: false,
        difficulty: "intermediate",
        tags: ["cycles","history","demand","supply","crisis"],
        prerequisites: ["geopolitical-risk-energy"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 5,
      },
      {
        slug: "crude-oil-futures",
        title: "Crude Oil Futures and Term Structure",
        summary: 
          "NYMEX WTI, ICE Brent; contango and backwardation; calendar spreads and inventory signals",
        duration: "15 min",
        price: 1.99,
        gumroadId: "crude-oil-futures",
        featured: false,
        difficulty: "intermediate",
        tags: ["futures","WTI","Brent","term-structure","contango","backwardation"],
        prerequisites: ["historical-cycles-oil"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 6,
      },
      {
        slug: "crude-oil-refined-products",
        title: "Crude Oil and Refined Products",
        summary: 
          "WTI, Brent, Dubai/Oman; crude quality and regional differentials; crack spreads and refining economics",
        duration: "10 min",
        price: 0.99,
        gumroadId: "crude-oil-refined-products",
        featured: false,
        difficulty: "intermediate",
        tags: ["crude-oil","WTI","Brent","crack-spreads","refining"],
        prerequisites: ["crude-oil-futures"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 7,
      },
      {
        slug: "calendar-spreads-energy",
        title: "Calendar Spreads in Energy",
        summary: 
          "Spread structure, roll cost, and inventory; trading and hedging with calendar spreads",
        duration: "15 min",
        price: 1.99,
        gumroadId: "calendar-spreads-energy",
        featured: false,
        difficulty: "intermediate",
        tags: ["calendar-spreads","contango","backwardation","roll","inventory"],
        prerequisites: ["crude-oil-refined-products"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 9,
      },
      {
        slug: "basis-trading-energy",
        title: "Basis Trading in Energy",
        summary: 
          "Location and quality basis; WTI-Brent and regional spreads; basis risk in hedging",
        duration: "15 min",
        price: 1.99,
        gumroadId: "basis-trading-energy",
        featured: false,
        difficulty: "intermediate",
        tags: ["basis","WTI-Brent","location","quality","hedging"],
        prerequisites: ["calendar-spreads-energy"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 10,
      },
      {
        slug: "energy-derivatives-instruments",
        title: "Energy Derivatives: Futures, Swaps, Options",
        summary: 
          "Energy futures, swaps, options; Asian options; term structure and inventory signals",
        duration: "20 min",
        price: 1.99,
        gumroadId: "energy-derivatives-instruments",
        featured: false,
        difficulty: "advanced",
        tags: ["energy","derivatives","futures","swaps","options"],
        prerequisites: ["basis-trading-energy"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 11,
      },
      {
        slug: "trading-systems-execution",
        title: "Trading Systems and Execution Infrastructure",
        summary: 
          "OMS/EMS logic, execution controls, market data and routing, and workflow design for commodity desks",
        duration: "10 min",
        price: 0.99,
        gumroadId: "trading-systems-execution-commodities",
        featured: false,
        difficulty: "intermediate",
        tags: ["trading-systems","OMS","EMS","execution","commodity-desks"],
        prerequisites: ["energy-derivatives-instruments"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 11,
      },
      {
        slug: "statistical-arbitrage-oil",
        title: "Statistical Arbitrage in Oil Markets",
        summary: 
          "Mean reversion and momentum; pairs and spread models; backtesting and risk limits",
        duration: "10 min",
        price: 0.99,
        gumroadId: "statistical-arbitrage-oil",
        featured: false,
        difficulty: "advanced",
        tags: ["stat-arb","mean-reversion","momentum","pairs-trading","backtesting"],
        prerequisites: ["basis-trading-energy"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 12,
      },
      {
        slug: "spread-trading-advanced",
        title: "Spread Trading: Advanced Strategies",
        summary: 
          "Crack spreads, spark spreads, multi-leg positions; refining margin and hedging",
        duration: "15 min",
        price: 0.99,
        gumroadId: "spread-trading-advanced",
        featured: false,
        difficulty: "advanced",
        tags: ["crack-spread","spark-spread","refining","multi-leg","hedging"],
        prerequisites: ["statistical-arbitrage-oil"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 13,
      },
      {
        slug: "natural-gas-lng",
        title: "Natural Gas Markets and LNG",
        summary: 
          "Global gas supply and demand; LNG value chain and trade; Henry Hub and international pricing",
        duration: "15 min",
        price: 0.99,
        gumroadId: "natural-gas-lng",
        featured: false,
        difficulty: "intermediate",
        tags: ["natural-gas","LNG","Henry-Hub","pricing","trade"],
        prerequisites: ["energy-derivatives-instruments"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 14,
      },
      {
        slug: "natural-gas-derivatives",
        title: "Natural Gas Derivatives and Trading",
        summary: 
          "Henry Hub, TTF; seasonal spreads, spark spread, basis risk; hedging for producers and utilities",
        duration: "10 min",
        price: 0.99,
        gumroadId: "natural-gas-derivatives",
        featured: false,
        difficulty: "intermediate",
        tags: ["natural-gas","Henry-Hub","TTF","spark-spread","basis","hedging"],
        prerequisites: ["natural-gas-lng"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 15,
      },
      {
        slug: "power-markets",
        title: "Power Markets",
        summary: 
          "Non-storability of power; balancing, congestion, locational pricing; spark and dark spreads; weather and renewable intermittency",
        duration: "10 min",
        price: 0.99,
        gumroadId: "power-markets",
        featured: false,
        difficulty: "intermediate",
        tags: ["power","electricity","spark-spread","balancing","renewables"],
        prerequisites: ["natural-gas-derivatives"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 16,
      },
      {
        slug: "refinery-hedging",
        title: "Refinery Hedging Programmes",
        summary: 
          "Locking refining margin; static and dynamic hedging; multi-horizon and risk infrastructure",
        duration: "10 min",
        price: 0.99,
        gumroadId: "refinery-hedging",
        featured: false,
        difficulty: "intermediate",
        tags: ["refinery","hedging","crack-spread","margin","risk"],
        prerequisites: ["power-markets"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 17,
      },
      {
        slug: "energy-hedging-practice",
        title: "Energy Hedging in Practice",
        summary: 
          "Producer hedging; airline and utility hedging; industrial consumer hedging; basis and mismatch risk",
        duration: "10 min",
        price: 0.99,
        gumroadId: "energy-hedging-practice",
        featured: false,
        difficulty: "intermediate",
        tags: ["energy","hedging","producer","utility","airline"],
        prerequisites: ["refinery-hedging"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 18,
      },
      {
        slug: "producer-consumer-hedging",
        title: "Producer and Consumer Hedging Programmes",
        summary: 
          "Objectives, governance, and execution; volume and timing uncertainty; hedge accounting and disclosure",
        duration: "10 min",
        price: 0.99,
        gumroadId: "producer-consumer-hedging",
        featured: false,
        difficulty: "intermediate",
        tags: ["hedging","producer","consumer","governance","hedge-accounting"],
        prerequisites: ["energy-hedging-practice"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 19,
      },
      {
        slug: "var-stress-testing-commodities",
        title: "VaR, Expected Shortfall, and Stress Testing in Commodities",
        summary: 
          "Value-at-Risk and Expected Shortfall for commodity portfolios; stress scenarios; backtesting",
        duration: "10 min",
        price: 0.99,
        gumroadId: "var-stress-testing-commodities",
        featured: false,
        difficulty: "advanced",
        tags: ["VaR","expected-shortfall","stress-testing","commodities","risk"],
        prerequisites: ["producer-consumer-hedging"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 20,
      },
      {
        slug: "storage-logistics-transport",
        title: "Storage, Logistics, and Transportation Risk",
        summary: 
          "Inventory risk; logistics and freight; pipeline and vessel capacity; insurance and force majeure",
        duration: "20 min",
        price: 1.99,
        gumroadId: "storage-logistics-transport",
        featured: false,
        difficulty: "intermediate",
        tags: ["storage","logistics","transport","freight","inventory"],
        prerequisites: ["var-stress-testing-commodities"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 21,
      },
      {
        slug: "carbon-climate-transition",
        title: "Carbon, Climate, and Transition Finance",
        summary: 
          "Carbon intensity, fossil fuel transition pressure, climate scenario analysis, and green and transition instruments",
        duration: "10 min",
        price: 0.99,
        gumroadId: "carbon-climate-transition",
        featured: false,
        difficulty: "intermediate",
        tags: ["carbon","climate","transition-finance","green-bonds","scenarios"],
        prerequisites: ["storage-logistics-transport"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 22,
      },
      {
        slug: "case-studies-trading",
        title: "Case Studies: Trading Wins and Losses",
        summary: 
          "Real cases in energy trading; lessons on discipline, leverage, and risk",
        duration: "10 min",
        price: 0.99,
        gumroadId: "case-studies-trading",
        featured: false,
        difficulty: "intermediate",
        tags: ["case-studies","trading","risk","lessons","discipline"],
        prerequisites: ["carbon-climate-transition"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 23,
      },
      {
        slug: "commodities-transition-economy",
        title: "Commodities in the Transition Economy",
        summary: 
          "Metals for electrification, gas as transition fuel, stranded asset risk, and commodity winners and losers in decarbonisation",
        duration: "10 min",
        price: 0.99,
        gumroadId: "commodities-transition-economy",
        featured: false,
        difficulty: "intermediate",
        tags: ["transition","electrification","stranded-assets","decarbonisation"],
        prerequisites: ["case-studies-trading"],
        category: "commodities-energy",
        tier: "professional",
        seriesOrder: 24,
      },
    ],
  },
];
